import { render, staticRenderFns } from "./Airticketgaiqiantuipiao.vue?vue&type=template&id=1012fd93&scoped=true"
import script from "./Airticketgaiqiantuipiao.vue?vue&type=script&lang=js"
export * from "./Airticketgaiqiantuipiao.vue?vue&type=script&lang=js"
import style0 from "./Airticketgaiqiantuipiao.vue?vue&type=style&index=0&id=1012fd93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1012fd93",
  null
  
)

export default component.exports